import createIcon from '../../createIcon';

/**
 * @component @name StickyNote2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g0Ljk5QzMuODkgMyAzIDMuOSAzIDVMMy4wMSAxOUMzLjAxIDIwLjEgMy45IDIxIDUgMjFIMTVMMjEgMTVWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTcgOEgxN1YxMEg3VjhaTTEyIDE0SDdWMTJIMTJWMTRaTTE0IDE5LjVWMTRIMTkuNUwxNCAxOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StickyNote2 = createIcon('StickyNote2', [
  [
    'path',
    {
      d: 'M19 3H4.99C3.89 3 3 3.9 3 5L3.01 19C3.01 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM7 8H17V10H7V8ZM12 14H7V12H12V14ZM14 19.5V14H19.5L14 19.5Z',
      key: 'tmt2nt',
    },
  ],
]);

export default StickyNote2;
